<template>
  <el-dialog :close-on-click-modal="false" :show="show" :visible="visible" height="20%" style="text-align:center"
             title="煤源数据分享" width="40%" @close="close" >
    <el-form ref="ruleForm" :model="ruleForm" :rules="rules" class="demo-ruleForm" label-width="100px"
             style="text-align:center">
      <el-form-item label="系统优惠" prop="sysDiscount">
        <el-input v-model.number="ruleForm.sysDiscount" placeholder="请输入系统优惠" type="number"></el-input>
      </el-form-item>
      <div style="display: flex;flex-wrap: wrap;width: 100%;justify-content: center;">
        <el-button v-show="updateBtn" class="btn" type="primary" @click="commit()">保存</el-button>
        <el-button class="btn close" @click="close()">取消</el-button>
      </div>
    </el-form>
  </el-dialog>
</template>
<script>
import base from '../../../utils/base'

export default {
  name: 'cocalShareDialogNew',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    rowData: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  watch: {
    show() {
      this.visible = this.show;
      if (this.show) {
        window.vm = this;
      }
    },
    rowData() {
      this.ruleForm = this.rowData;
    },
  },
  data() {

    return {
      updateBtn: true,
      url: base.get().url,
      visible: false,
      ruleForm: {
        sysDiscount: 0,
      },
      rules: {
        sysDiscount: [
          {required: true, message: '请输入系统优惠', trigger: 'blur'},
        ],
      }
    }
  },
  methods: {

    close() {
      this.updateBtn = true;
      this.$emit("listenToChildEvent", false);
    },
    commit() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.ruleForm.cocalId = this.rowData.id;
          let cocalData = JSON.stringify(this.ruleForm);
          let loading = this.$loading({
            lock: true,
            text: '分享中，请稍候.....',
            background: 'rgba(0,0,0,0.5)'
          });
          this.$http({
            url: this.url + `cocalTemplate/` + "cocalShare",
            method: "post",
            data: cocalData
          }).then(res => {
            loading.close();
            if (res.data.code === 0) {
              this.$message.success(res.data.msg);
              this.close();
            }
          })
        }
      })
    },

  },


}
</script>
<style lang="scss">
.el-form-item__label {
  font-weight: bold
}
</style>